import React from 'react';

type DashboardView = 'routes' | 'trips' | 'create-route' | 'create-trip' | 'requests';

interface DashboardNavigationProps {
  activeView: DashboardView;
  onViewChange: (view: DashboardView) => void;
  user: { first_name?: string; last_name?: string } | null;
  onLogout: () => void;
}

const DashboardNavigation: React.FC<DashboardNavigationProps> = ({
  activeView,
  onViewChange,
  user,
  onLogout
}) => {
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <span>🚗 RouteShare Dashboard</span>
      </div>
      <ul className="navbar-nav">
        <li>
          <button
            onClick={() => onViewChange('routes')}
            className={`nav-link ${
              activeView === 'routes' 
                ? 'bg-blue-600' 
                : ''
            }`}
            style={{ 
              background: activeView === 'routes' ? 'rgba(59, 130, 246, 0.8)' : 'none', 
              border: 'none', 
              cursor: 'pointer',
              color: 'white'
            }}
          >
            🗺️ Routes
          </button>
        </li>
        <li>
          <button
            onClick={() => onViewChange('trips')}
            className={`nav-link ${
              activeView === 'trips' 
                ? 'bg-blue-600' 
                : ''
            }`}
            style={{ 
              background: activeView === 'trips' ? 'rgba(59, 130, 246, 0.8)' : 'none', 
              border: 'none', 
              cursor: 'pointer',
              color: 'white'
            }}
          >
            🚗 Trips
          </button>
        </li>
        <li>
          <button
            onClick={() => onViewChange('create-route')}
            className="nav-link"
            style={{ 
              background: activeView === 'create-route' ? 'rgba(34, 197, 94, 0.8)' : 'rgba(34, 197, 94, 0.6)', 
              border: 'none', 
              cursor: 'pointer',
              color: 'white',
              fontWeight: 'bold'
            }}
          >
            ➕ Create Route
          </button>
        </li>
        <li>
          <button
            onClick={() => onViewChange('create-trip')}
            className="nav-link"
            style={{ 
              background: activeView === 'create-trip' ? 'rgba(59, 130, 246, 0.8)' : 'rgba(59, 130, 246, 0.6)', 
              border: 'none', 
              cursor: 'pointer',
              color: 'white',
              fontWeight: 'bold'
            }}
          >
            ➕ Post Trip
          </button>
        </li>
        <li>
          <span className="nav-link" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
            Welcome, {[user?.first_name, user?.last_name].filter(Boolean).join(' ')}!
          </span>
        </li>
        <li>
          <button
            onClick={onLogout}
            className="nav-link"
            style={{ 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer',
              color: 'white'
            }}
          >
            Logout
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default DashboardNavigation;
